import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-payments-expected-delayed-list',
  templateUrl: './dashboard-payments-expected-delayed-list.component.html',
  styleUrls: ['./dashboard-payments-expected-delayed-list.component.scss']
})
export class DashboardPaymentsExpectedDelayedListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
